<template>
    <table class="table" :class="{ 'mb-5': state.administrativoGrupo }">
        <thead>
            <tr>
                <th class="chamado d-print-grid text-center">
                    <input type="checkbox" class="form-check-input" id="marcarTodos" @click="marcarTodos()">
                    <!-- <button class="btn p-0" @click="marcarTodos()">X</button> -->
                </th>
                <th class="chamado d-print-grid">Chamado</th>
                <th class="identificacaoQuartoTelaMaior text-center d-print-grid">Setor</th>
                <th class="identificacaoQuartoTelaMaior text-center d-print-grid">Quarto</th>
                <th class="identificacaoQuartoTelaMaior text-center d-print-grid">Leito</th>
                <th class="identificacaoQuartoTelaMenor text-center d-print-grid">Código Leito</th>
                <th class="text-center d-print-grid">Dt Chamado</th>
                <th class="dataEncerramento d-print-grid text-center">Dt Encerramento</th>
                <th class="d-print-grid text-end">Tempo Gasto</th>
                <th class="d-print-none">Administrativo</th>
            </tr>
        </thead>
        <tbody>
            <tr class="linha fundoMaisClaro" v-for="(d, index) in dChamado" :key="index"
                :style="{ 'backgroundColor': d.tipoChamado.cor }" @dblclick="ativarAdministrativoGrupo(d.id)">
                <td class="fundoMaisClaro chamado d-print-none pt-1 pb-1 text-center">
                    <input type="checkbox" class="form-check-input" :id="`checkChamado${d.id}`"
                        :disabled="d.posicao == 'AD'" @click="listarMarcados(d.id)">
                </td>
                <td class="fundoMaisClaro d-print-grid pt-1 pb-1 chamado">
                    {{ d.tipoChamado.descricao }}
                </td>
                <td class="fundoMaisClaro d-print-grid pt-1 pb-1 identificacaoQuartoTelaMaior text-center">
                    {{ d.leito.quarto.setor.descricao }}
                </td>
                <td class="fundoMaisClaro d-print-grid pt-1 pb-1 identificacaoQuartoTelaMaior text-center">
                    {{ d.leito.quarto.descricao }}
                </td>
                <td class="fundoMaisClaro d-print-grid pt-1 pb-1 identificacaoQuartoTelaMaior text-center">
                    {{ d.leito.descricao }}
                </td>
                <td class="fundoMaisClaro d-print-grid pt-1 pb-1 identificacaoQuartoTelaMenor text-center">
                    {{ d.leito.codigoLeito }}
                </td>
                <td class="fundoMaisClaro d-print-grid pt-1 pb-1 text-center">
                    {{ formatarData(d.data) }}, {{ d.hora }}
                </td>
                <!-- {{ new Date(d.data).getFullYear() }} -->
                <td class="fundoMaisClaro d-print-grid pt-1 pb-1 dataEncerramento text-center"
                    v-if="(d.hrFinalizacao != null)">
                    {{ formatarData(d.dtFinalizacao) }}, {{ d.hrFinalizacao }}
                </td>
                <td class="fundoMaisClaro d-print-grid pt-1 pb-1 dataEncerramento text-center"
                    v-if="(d.hrCancelamento != null && d.dtCancelamento != null)">
                    {{ formatarData(d.dtCancelamento) }}, {{ d.hrCancelamento }}
                </td>
                <td class="fundoMaisClaro d-print-grid pt-1 pb-1 dataEncerramento text-center"
                    v-if="(d.hrCancelamento != null && d.dtCancelamento == null) || (d.posicao == 'AD' && (d.hrCancelamento == null && d.dtFinalizacao == null))">
                    Cancelamento Administrativo
                </td>
                <td class="fundoMaisClaro d-print-grid pt-1 pb-1 dataEncerramento text-center" v-if="d.posicao == 'AB'">
                    Ainda não encerrado
                </td>
                <td class="fundoMaisClaro d-print-grid pt-1 pb-1 text-end">
                    {{ calcularTempoEspera(d) }}
                </td>
                <td class="fundoMaisClaro d-print-none pt-0 pb-0 col-sm-1 col-md-1">
                    <p class="mt-0 mb-0 pt-1 text-center" v-if="d.posicao == 'AD'">Sim</p>
                    <button class="btn btn-primary py-0 w-100" @click="transformarAdministrativo(d.id)"
                        v-if="d.posicao != 'AD'" :disabled="state.administrativoGrupo == true">Não</button>
                </td>
            </tr>
        </tbody>
    </table>
    <div class="w-100 position-fixed d-flex justify-content-end fundo pt-2 pb-2" style="bottom: 0px"
        v-if="state.administrativoGrupo == true">
        <!-- style="bottom: 20px" -->
        <button class="btn btn-danger" @click="fecharAdministrativoGrupo()">Cancelar</button>
        <button class="btn btn-success ms-1 me-2" @click="tornarGrupoAdministrativo()">Confirmar</button>
    </div>
    <ModalConfirmaAgape :visible="state.modalVisivel" :title="state.title" :text="state.text" @modalResult="modalResult">
        <template v-slot:motivo>
            <input type="text" class="form-control" v-model="state.motivo" placeholder="Obrigatório">
        </template>
    </ModalConfirmaAgape>

    <ModalConfirmaAgape v-if="state.semMotivoAdm" :visible="state.semMotivoAdm" :title="'Aviso'" :aviso="true"
        :text="'Insira um motivo para transformar em administrativo'" @modalResult="modalResultSemMotivo">
    </ModalConfirmaAgape>
</template>

<script setup>
import store from '@/store/store';
import api from "@/api/api";
import moment from 'moment';
import ModalConfirmaAgape from './ModalConfirmaAgape.vue';
import { reactive, defineProps, defineEmits, computed, onMounted } from 'vue';

const state = reactive({
    text: "Deseja transformar o(s) chamado(s) em cancelamento administrativo?",
    title: "Confirmar",
    modalVisivel: Boolean(),
    semMotivoAdm: Boolean(),
    idAux: Number(),
    motivo: String(),
    lstLinhasMarcadas: [],
    administrativoGrupo: Boolean(),
});

const props = defineProps(['dChamado', 'tpChamado']);
const emits = defineEmits(['carregarChamados']);

function formatarData(pData) {
    // return moment(pData).format("DD MMMM");
    return moment(pData).format("DD/MM/YYYY");
}

function descricao() {
    if (props.dChamado._tipoChamado._id_principal - 1 >= 0)
        return props.tpChamado[props.dChamado._tipoChamado._id_principal - 1]?.descricao;
}

function cor() {
    if (props.dChamado._tipoChamado._id_principal - 1 >= 0)
        return props.tpChamado[props.dChamado._tipoChamado._id_principal - 1]?.cor;
}

function calcularTempoEspera(d) {
    let dataFormatada;
    if (store.state.config.cronometro && d.posicao == "AB") {
        setInterval(() => {
            let dataDoServidor = new Date(d.data.split("T")[0] + "T" + d.hora);
            let dataAtual = new Date();
            let diferenca = new Date(dataAtual - dataDoServidor);
            dataFormatada = converterHora(diferenca);
        }, 1000);
        return dataFormatada;
    }
    if (store.state.config.cronometro && (d.posicao != "AB" && d.posicao != "AD")) {
        let dataDoServidor = new Date(d.data.split("T")[0] + "T" + d.hora);
        if (d.dtFinalizacao != null) {
            let dataFinalizacao = new Date(d.dtFinalizacao.split("T")[0] + "T" + d.hrFinalizacao);
            let diferenca = new Date(dataFinalizacao - dataDoServidor);
            dataFormatada = converterHora(diferenca);
        }
        else if (d.dtCancelamento != null) {
            let dataCancelamento = new Date(d.dtCancelamento.split("T")[0] + "T" + d.hrCancelamento);
            let diferenca = new Date(dataCancelamento - dataDoServidor);
            dataFormatada = converterHora(diferenca);
        }
        return dataFormatada;
    }
    if (store.state.config.cronometro && d.posicao == "AD") {
        dataFormatada = "Administrativo";
        return dataFormatada;
    }
}

function converterHora(diferenca) {
    let resultado = "";
    if (diferenca.getUTCDate() - 1) {
        resultado += diferenca.getUTCDate() - 1 + "d ";
    }

    if (diferenca.getUTCHours()) {
        resultado += diferenca.getUTCHours() + "h ";
    }

    if (diferenca.getUTCMinutes()) {
        diferenca.getUTCMinutes() > 9 ? resultado += diferenca.getUTCMinutes() + "m " : resultado += "0" + diferenca.getUTCMinutes() + "m ";
    }

    if (diferenca.getUTCSeconds()) {
        diferenca.getUTCSeconds() > 9 ? resultado += diferenca.getUTCSeconds() + "s " : resultado += "0" + diferenca.getUTCSeconds() + "s ";
    }
    return resultado;
}

function transformarAdministrativo(pIdTpChamado) {
    state.idAux = pIdTpChamado;
    state.modalVisivel = true;
}

function modalResult(result) {
    if (result === "ok") {
        if (state.motivo.trim().length > 0) {
            if (state.administrativoGrupo == false) {
                api.transferir(state.idAux, state.motivo)
                    .then(resp => {
                        if (resp == "Ok") {
                            state.motivo = String();
                            emits('carregarChamados');
                        }
                    });
            } else {
                state.lstLinhasMarcadas.forEach(async (l, i) => {
                    await api.transferir(l, state.motivo);
                    if (i == state.lstLinhasMarcadas.length - 1) {
                        state.motivo = String();
                        emits('carregarChamados');
                        fecharAdministrativoGrupo();
                    }
                });
            }
            state.modalVisivel = false;
        } else {
            state.semMotivoAdm = true;
        }
    } else {
        state.motivo = String();
        state.modalVisivel = false;
    }
}

function modalResultSemMotivo() {
    state.motivo = String();
    state.semMotivoAdm = false;
}

function listarMarcados(pIdChamado) {
    if (state.lstLinhasMarcadas.includes(pIdChamado)) {
        state.lstLinhasMarcadas = state.lstLinhasMarcadas.filter(l => l != pIdChamado);
        if (state.lstLinhasMarcadas.length == 0) {
            state.administrativoGrupo = false;
        }
        if (state.lstLinhasMarcadas.length < props.dChamado.length) {
            document.getElementById(`marcarTodos`).checked = false;
        }
    } else {
        state.administrativoGrupo = true;
        state.lstLinhasMarcadas.push(pIdChamado);
        if (state.lstLinhasMarcadas.length == props.dChamado.length) {
            document.getElementById(`marcarTodos`).checked = true;
        }
    }
}

function marcarTodos() {
    state.lstLinhasMarcadas = [];
    if (document.getElementById(`marcarTodos`).checked == true) {
        props.dChamado.forEach((c) => {
            if (document.getElementById(`checkChamado${c.id}`).disabled == false) {
                document.getElementById(`checkChamado${c.id}`).checked = true;
                if (!state.lstLinhasMarcadas.includes(c)) {
                    state.lstLinhasMarcadas.push(c.id);
                    document.getElementById(`checkChamado${c.id}`).checked = true;
                }
            }
        });
        state.administrativoGrupo = true;
    } else {
        props.dChamado.forEach((c) => {
            if (document.getElementById(`checkChamado${c.id}`).disabled == false) {
                document.getElementById(`checkChamado${c.id}`).checked = false;
                if (state.lstLinhasMarcadas.includes(c)) {
                    state.lstLinhasMarcadas.push(c.id);
                    document.getElementById(`checkChamado${c.id}`).checked = true;
                }
            }
        });
        state.administrativoGrupo = false;
    }
}

function ativarAdministrativoGrupo(pIdChamado) {
    state.administrativoGrupo = true;
    state.lstLinhasMarcadas.push(pIdChamado);
    document.getElementById(`checkChamado${pIdChamado}`).checked = !document.getElementById(`checkChamado${pIdChamado}`).checked;
}

function fecharAdministrativoGrupo() {
    state.lstLinhasMarcadas.forEach((l) => {
        if (document.getElementById(`checkChamado${l}`).checked)
            document.getElementById(`checkChamado${l}`).checked = false;
    });
    state.lstLinhasMarcadas = [];
    state.administrativoGrupo = false;
}

function tornarGrupoAdministrativo() {
    state.modalVisivel = true;
}

const config = computed(() => {
    return store.state.config;
});

const temporizadorLigado = computed(() => {
    return store.state.config.cronometro ? true : false;
});
</script>

<style scoped>
.linha {
    font-weight: bold
}

.chamado {
    display: table-cell;
}

.identificacaoQuartoTelaMaior {
    display: table-cell;
}

.identificacaoQuartoTelaMenor {
    display: none;
}

.fundoMaisClaro {
    background-color: rgba(255, 255, 255, 0.6);
}

.gridBotao {
    display: flex;
    justify-content: center;
    width: 100%;
}

@media only screen and (max-width: 576px) {
    .chamado {
        display: none !important;
    }

    .dataEncerramento {
        display: none;
    }
}

@media only screen and (max-width: 740px) {
    .identificacaoQuartoTelaMaior {
        display: none;
    }

    .chamado {
        display: table-cell;
    }

    .identificacaoQuartoTelaMenor {
        display: table-cell;
    }
}
</style>